import XVisuals from './Visuals.vue'
export default XVisuals